/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Artifact_HintInputs */

const en_reading_class_artifact_hint = /** @type {(inputs: Reading_Class_Artifact_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan noise, stamps and watermarks`)
};

const es_reading_class_artifact_hint = /** @type {(inputs: Reading_Class_Artifact_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruido de escaneo, sellos y marcas de agua`)
};

/**
* | output |
* | --- |
* | "Scan noise, stamps and watermarks" |
*
* @param {Reading_Class_Artifact_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_artifact_hint = /** @type {((inputs?: Reading_Class_Artifact_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Artifact_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_artifact_hint(inputs)
	return en_reading_class_artifact_hint(inputs)
});